export const authRoles = {
  sa: ['SA'], // Only Super Admin has access
  admin: [1, 2], // Only SA & Admin has access
  editor: [2, 3, 4], // Only SA & Admin & Editor has access
  guest: ['SA', 'ADMIN', 'EDITOR', 'GUEST'], // Everyone has access
};
